const BluePin = () => {
	return (
		<svg
			width="27"
			height="32"
			viewBox="0 0 27 32"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M22.8267 3.90644C20.321 1.40713 16.9227 0.002055 13.3786 2.25236e-06C9.83443 -0.00205049 6.43447 1.39908 3.92585 3.8955C1.41722 6.39191 0.00517551 9.77935 1.41987e-05 13.3134C-0.00514711 16.8475 1.397 20.239 3.89832 22.7427L12.4071 31.5899C12.5319 31.7195 12.6817 31.8227 12.8475 31.8932C13.0133 31.9637 13.1917 32 13.372 32C13.5522 32 13.7306 31.9637 13.8965 31.8932C14.0623 31.8227 14.2121 31.7195 14.3369 31.5899L22.8267 22.7622C25.3307 20.2599 26.737 16.8693 26.737 13.3343C26.737 9.79935 25.3307 6.40874 22.8267 3.90644Z"
				fill="#494C83"
			/>
			<path
				d="M13.3717 16.7614C15.2468 16.7614 16.7669 15.2264 16.7669 13.3329C16.7669 11.4393 15.2468 9.9043 13.3717 9.9043C11.4966 9.9043 9.97656 11.4393 9.97656 13.3329C9.97656 15.2264 11.4966 16.7614 13.3717 16.7614Z"
				fill="white"
			/>
		</svg>
	);
};

export default BluePin;
